import React from 'react';
import cx from 'classnames';
import replaceHttpToHttps from '@src/utils/replace-url-to-https';

import styles from './index.less';
import { px2rem } from '@src/utils/rem-util';

export default class BackgroundImage extends React.PureComponent {
  render() {
    let { className, src, tag: Component, width, height, rem, backgroundRepeat, mergeStyle, ...props } = this.props;
    if (Number(width)) {
      width = width + 'px';
    }
    if (Number(height)) {
      height = height + 'px';
    }
    if (rem) {
      width = px2rem(width);
      height = px2rem(height);
    }
    return (
      <Component
        className={cx(styles.root, className)}
        style={{
          backgroundImage: src ? `url(${replaceHttpToHttps(src)})` : undefined,
          backgroundSize: `${width} ${height}`,
          backgroundRepeat,
          width,
          height,
          ...mergeStyle
        }}
        {...props}
      />
    );
  }
}

BackgroundImage.defaultProps = {
  tag: 'div',
  backgroundRepeat: 'no-repeat',
  mergeStyle: {}
};
